import { defineMessages } from 'react-intl';

const messages = defineMessages({
  required: {
    id: 'helpers.validation.required',
    defaultMessage: 'This is required',
  },
  match: {
    id: 'helpers.validation.match',
    defaultMessage: "Fields don't match",
  },
  minLength: {
    id: 'helpers.validation.minLength',
    defaultMessage: 'Please enter at least {min} characters',
  },
  maxLength: {
    id: 'helpers.validation.maxLength',
    defaultMessage: 'Please enter at most {max} characters',
  },
  isAlpha: {
    id: 'helpers.validation.isAlpha',
    defaultMessage: 'Must be letters only',
  },
  noSpaceAtStartAndEnd: {
    id: 'helpers.validation.noSpaceAtStartAndEnd',
    defaultMessage: `Please choose a password that doesn't have a space at the start or end.`,
  },
  containsAlpha: {
    id: 'helpers.validation.containsAlpha',
    defaultMessage: 'Must contain letters',
  },
  containsLowerAlpha: {
    id: 'helpers.validation.containsLowerAlpha',
    defaultMessage: 'Must contain a lowercase letter',
  },
  containsUpperAlpha: {
    id: 'helpers.validation.containsUpperAlpha',
    defaultMessage: 'Must contain an uppercase letter',
  },
  minWords: {
    id: 'helpers.validation.minWords',
    defaultMessage: 'Must be {min} words or more',
  },
  isAlphaNumeric: {
    id: 'helpers.validation.isAlphaNumeric',
    defaultMessage: 'Must be letters and numbers only',
  },
  isNumber: {
    id: 'helpers.validation.isNumber',
    defaultMessage: 'Please only use numbers in this field',
  },
  isSupportedLocation: {
    id: 'helpers.validation.isSupportedCountry',
    defaultMessage:
      'Unfortunately we’re not covering your location at the moment. ' +
      'We’re looking to expand in the near future, so please try again at a later date.',
  },
  containsNumber: {
    id: 'helpers.validation.containsNumber',
    defaultMessage: 'Must contain a number',
  },
  minNumber: {
    id: 'helpers.validation.minNumber',
    defaultMessage: 'Number must be at least {min}',
  },
  maxNumber: {
    id: 'helpers.validation.maxNumber',
    defaultMessage: 'Number must be less than or equal to {max}',
  },
  containsSpecialChars: {
    id: 'helpers.validation.containsSpecialChars',
    defaultMessage: 'Must contain one of the following characters: {chars}',
  },
  isEmail: {
    id: 'helpers.validation.isEmail',
    defaultMessage: 'Please enter a valid email address',
  },
  isPhone: {
    id: 'helpers.validation.isPhone',
    defaultMessage: 'Please enter a valid phone number',
  },
  isDateGeneric: {
    id: 'helpers.validation.isDateGeneric',
    defaultMessage: 'The date provided must follow the following format - DD/MM/YYYY',
  },
  isDateYear: {
    id: 'helpers.validation.isDateYear',
    defaultMessage: 'Please enter a valid year',
  },
  isDateMonth: {
    id: 'helpers.validation.isDateMonth',
    defaultMessage: 'Please enter a valid month',
  },
  isDateDay: {
    id: 'helpers.validation.isDateDay',
    defaultMessage: 'Please enter a valid day',
  },
  passwordRequirementsMinLength: {
    id: 'helpers.validation.passwordRequirementsMinLength',
    defaultMessage: 'A minimum of 8 characters',
  },
  passwordRequirementsContainsNumber: {
    id: 'helpers.validation.passwordRequirementsContainsNumber',
    defaultMessage: 'A number',
  },
  passwordRequirementsContainsUppercase: {
    id: 'helpers.validation.passwordRequirementsContainsUppercase',
    defaultMessage: 'An uppercase letter',
  },
  regionRequired: {
    id: 'helpers.validation.regionRequired',
    defaultMessage: 'Region is required',
  },
  postcodeRequired: {
    id: 'helpers.validation.postcodeRequired',
    defaultMessage: 'Postcode is required',
  },
  locationError: {
    id: 'helpers.validation.locationError',
    defaultMessage:
      'Unfortunately we’re not covering your location at the moment. ' +
      'We’re looking to expand in the near future, so check back later.',
  },
  invalidType: {
    id: 'helpers.validation.invalidType',
    defaultMessage: 'The type is invalid',
  },
  invalidValue: {
    id: 'helpers.validation.invalidValue',
    defaultMessage: 'This is invalid',
  },
  hexValue: {
    id: 'helpers.validation.hexValue',
    defaultMessage: 'Please enter a valid HEX code including #',
  },
  emailOrPhoneLabel: {
    id: 'form.emailOrPhoneLabel',
    defaultMessage: 'Email address or phone number (include country code)',
  },
  emailAddressLabel: {
    id: 'form.emailAddressLabel',
    defaultMessage: 'Email address',
  },
  emailOrPhoneHintText: {
    id: 'form.emailOrPhoneHintText',
    defaultMessage: 'For phone numbers, please include country code. e.g. +61123456789',
  },
  amazonEmailHintText: {
    id: 'form.amazonEmailHintText',
    defaultMessage:
      `Please enter the email address you'd like to associate this policy with. ` +
      'This could be your Amazon account email or one you have with us already',
  },
  invalidEmailOrPhone: {
    id: 'form.invalidEmailOrPhone',
    defaultMessage: 'Please enter a valid email address or phone number',
  },
  dobMaxAge: {
    id: 'form.validation.dobMaxAge',
    defaultMessage: 'Please enter a valid date of birth',
  },
});

export default messages;

export const yupMessages = {
  mixed: {
    required: JSON.stringify({ descriptor: messages.required }),
  },
  string: {
    email: JSON.stringify({ descriptor: messages.isEmail }),
    min: JSON.stringify({ descriptor: messages.minLength, value: { min: '${min}' } }),
    max: JSON.stringify({ descriptor: messages.maxLength, value: { max: '${max}' } }),
  },
  number: {
    isNumber: JSON.stringify({ description: messages.isNumber }),
  },
  array: {
    min: JSON.stringify({ descriptor: messages.required }),
  },
};
